import React from 'react';
import Button from 'common/components/Button';
import classNames from 'classnames';

import propTypes from 'propTypes';

class PillCheckbox extends React.Component {
  static propTypes = {
    meta: propTypes.FormMeta.isRequired,
  };

  render() {
    const { label, input, meta, className, ...props } = this.props;
    const id = `checkbox-${input.name}-${Date.now()}`;

    return (
      <div className={classNames(className, 'PillCheckbox')}>
        <div className="PillCheckbox__pill">
          <input
            className="PillCheckbox__checkbox"
            type="checkbox"
            id={id}
            {...input}
          />
          <label htmlFor={id}>
            <Button.Pill className="PillCheckbox__button" checked={input.value}>
              {label}
            </Button.Pill>
          </label>
        </div>
      </div>
    );
  }
}

export default PillCheckbox;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Form/PillCheckbox.js